<template>
  <div>
    <el-form :model="form" label-width="100px" style="width: 500px; margin: 20px auto;">
      <el-form-item label="物料选择">
        <MaterialLov 
          v-model="form.materialId" 
          @callBack="handleMaterialSelect"
          width="100%" />
      </el-form-item>
      
      <el-form-item label="物料批次">
        <el-input v-model="form.batch" />
      </el-form-item>
      
      <el-form-item label="物料价格">
        <el-input-number v-model="form.price" :precision="2" :step="0.1" />
      </el-form-item>
      
      <el-form-item label="数量">
        <el-input-number v-model="form.num" :min="1" />
      </el-form-item>
      
      <el-form-item label="描述">
        <el-input v-model="form.description" type="textarea" />
      </el-form-item>
      
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import MaterialLov from '@/views/ticket/lov/MaterialLov.vue'
import requestTicket from '@/utils/requestTicket'

export default {
  name: "Storage",
  components: {
    MaterialLov
  },
  data() {
    return {
      form: {
        materialId: null,
        batch: '',
        price: 0,
        num: 1,
        description: ''
      }
    }
  },
  methods: {
    handleMaterialSelect(material) {
      console.log('选中的物料:', material)
      // 可以在这里处理选中物料后的逻辑
    },

    async onSubmit() {
      if (!this.form.materialId) {
        this.$message.warning('请选择物料')
        return
      }

      try {
        const res = await requestTicket.post('/Ticketing/material-item/save', this.form)
        if (res.code === 200) {
          this.$message.success('保存成功')
          this.resetForm()
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败')
      }
    },

    resetForm() {
      this.form = {
        materialId: null,
        batch: '',
        price: 0,
        num: 1,
        description: ''
      }
    }
  }
}
</script>

<style scoped>

</style>